import Lock from "../../assets/images/lock.png";
import ResetPermissionsImage from "../../assets/images/reset_permissions.png";
import Error from "../../assets/icons/error.png";

import "./styles.scss";

import { ResetPermissionsProps } from "./types";

const ResetPermissions = ({ styles }: ResetPermissionsProps) => (
  <div className="reset-permissions" style={styles}>
    <h3>
      <img src={Error} alt="error_img" width={50} /> Please give permissions for
      camera and location.
    </h3>
    <h2>Steps to reset permissions:</h2>
    <div className="pointer-container">
      <div className="bullet-point">
        <div className="image-container">
          <img src={Lock} alt="lock_img" width={50} />
          <div>
            Click on the lock icon on the top of the browser in the URL bar
          </div>
        </div>
      </div>

      <div className="bullet-point">
        <div className="image-container">
          <img
            src={ResetPermissionsImage}
            width={150}
            alt="reset_permissions_img"
          />
          <div>Click on Reset Permission button.</div>
        </div>
      </div>

      <div className="bullet-point">
        <div className="image-container"> Now open the link again.</div>
      </div>
    </div>
  </div>
);

export default ResetPermissions;
